import React from "react";
import '../Qrcode.css';
import InputText from "../../containers/app/InputText";

const PartHeader = () => (
    <div className="breadcomb-area">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="breadcomb-list">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div className="breadcomb-wp">
                                    <div className="breadcomb-ctn qr-j1">
                                        <h2>输入二维码网址</h2>
                                        <InputText/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)

export default PartHeader
